import { BmHttp } from "../utils/Global";

// COBERTURAS-06 -- Reporte General de Atenciones y Estado de Cobertura.
// Analítico / solo lectura.

const buildParams = ({ page, limit, filters = {} }) => ({
    page,
    limit,
    fecha_inicial: filters.fecha_inicial,
    fecha_final: filters.fecha_final,
    idclinica: filters.idclinica,
    aseguradora: filters.aseguradora,
    paciente: filters.paciente,
    examen: filters.examen,
    especialidad: filters.especialidad,
    medico: filters.medico,
    plan: filters.plan,
    tipo_cobertura: filters.tipo_cobertura,
    estado_responsabilidad_seguro: filters.estado_responsabilidad_seguro,
});

export const GetReporteAtenciones = async ({ page = 1, limit = 20, filters }) => {
    try {
        const { data } = await BmHttp().get(`reporte/coberturas/atenciones`, { params: buildParams({ page, limit, filters }) });
        return data;
    } catch (error) {
        return error.response?.data || { success: false, data: [], message: "Error de red" };
    }
};

export const GetReporteAtencionesExcel = async ({ filters }) => {
    return BmHttp().get(`reporte/coberturas/atenciones/excel`, {
        params: buildParams({ filters }),
        responseType: "blob",
    });
};

export const GetReporteAtencionesPdf = async ({ filters }) => {
    return BmHttp().get(`reporte/coberturas/atenciones/pdf`, {
        params: buildParams({ filters }),
        responseType: "blob",
    });
};
